import { useEffect } from "react";
import { useClient } from "../context/ClientProvider";

const useWebchatScript = () => {
  const { useGetConfig } = useClient();
  const { clientConfig } = useGetConfig();

  useEffect(() => {
    const widgetConfig = clientConfig?.layout?.chatWidget;

    if (clientConfig?.layout?.chatWidget?.enabled ?? false) {
      const buttonColour = widgetConfig.buttonColour;

      const s = document.createElement("script");
      s.src = widgetConfig.connectScriptUrl;
      s.async = 1;
      s.id = widgetConfig.widgetId;
      document.getElementsByTagName("head")[0].appendChild(s);
      window["amazon_connect"] =
        window["amazon_connect"] ||
        function () {
          window["amazon_connect"].ac = window["amazon_connect"].ac || [];
          window["amazon_connect"].ac.push(arguments);
        };
      const amazon_connect = window["amazon_connect"];
      amazon_connect("styles", {
        iconType: "CHAT",
        openChat: { color: "#ffffff", backgroundColor: buttonColour },
        closeChat: { color: "#ffffff", backgroundColor: buttonColour },
      });
      amazon_connect("snippetId", widgetConfig.snippetId);
      amazon_connect("supportedMessagingContentTypes", [
        "text/plain",
        "text/markdown",
        "application/vnd.amazonaws.connect.message.interactive",
        "application/vnd.amazonaws.connect.message.interactive.response",
      ]);
    } else {
      if (widgetConfig?.widgetId) {
        const script = document.getElementById(widgetConfig.widgetId);
        if (script) {
          script.remove();
        }
      }
      if (window["amazon_connect"]) {
        delete window["amazon_connect"];
      }
      const button = document.getElementById("amazon-connect-chat-widget");
      if (button) {
        button.remove();
      }
    }
  }, [clientConfig]);
};

export default useWebchatScript;
